import {
  CREATE_COMS_CHANNEL_CONFIG_PROJECT,
  CREATE_COMS_CHANNEL_CONFIG_PROJECT_SUCCESS,
  CREATE_COMS_CHANNEL_CONFIG_PROJECT_EMPTY,
  CREATE_COMS_CHANNEL_CONFIG_PROJECT_ERROR,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateComsChannelConfig = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COMS_CHANNEL_CONFIG_PROJECT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_COMS_CHANNEL_CONFIG_PROJECT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_COMS_CHANNEL_CONFIG_PROJECT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_COMS_CHANNEL_CONFIG_PROJECT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateComsChannelConfig;
